/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Ocop_Cta_Label1Inputs */

const vi_sitesettings_ocop_cta_label1 = /** @type {(inputs: Sitesettings_Ocop_Cta_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chữ nút mua sản phẩm OCOP`)
};

/**

* @param {Sitesettings_Ocop_Cta_Label1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_ocop_cta_label1 = /** @type {((inputs?: Sitesettings_Ocop_Cta_Label1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Ocop_Cta_Label1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_ocop_cta_label1(inputs)
});
export { sitesettings_ocop_cta_label1 as "siteSettings_ocop_cta_label" }